import {
  createMultiStyleConfigHelpers,
  defineStyle,
  extendTheme,
  type ThemeConfig,
} from "@chakra-ui/react";
import { checkboxAnatomy } from "@chakra-ui/anatomy";
import { buttonTheme } from "./components/button";
import { drawerTheme } from "./components/drawer";

const config: ThemeConfig = {
  initialColorMode: "light",
  useSystemColorMode: false,
};

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(checkboxAnatomy.keys);

const circular = definePartsStyle({
  control: defineStyle({
    rounded: "full",
  }),
});

const checkboxTheme = defineMultiStyleConfig({
  variants: { circular },
});

const theme = extendTheme({
  config,
  fonts: {
    font1: "New Spirit",
    font2: `'Plus Jakarta Sans', sans-serif`,
    font3: "Gopher",
    font4: "DM Sans",
    font5: "Gilda Display",
    font6: "Glacial",
  },
  breakpoints: {
    sm: "330px",
  },
  components: {
    Checkbox: checkboxTheme,
    Button: buttonTheme,
    Drawer: drawerTheme,
  },
});

export default theme;
